import { USER_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TUserSelector, TEqualityFunction } from '../types';

export const useUserSelector = <TSelected>(selector: TUserSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof USER_REDUCER>(USER_REDUCER, selector, equalityFn);
};
